import { accessShops } from "@/api/shop";

const shop = {
  namespaced: true,

  state: {
    // shopList: JSON.parse(localStorage.getItem("shops")), // 门店列表
    shopList: null,
    isFetching: false,
  },
  mutations: {
    setShopList(state, shopList) {
      state.shopList = shopList;
    },
    setIsFetching(state, isFetching) {
      state.isFetching = isFetching;
    },
  },
  actions: {
    async fetchShops({ commit, state }) {
      if (state.isFetching) return;

      commit("setIsFetching", true);
      try {
        const response = await accessShops({
          page: 1,
          status: 0,
          style: "simple",
        });
        commit("setShopList", response.list);
      } catch (error) {
        console.error("Error fetching shop list:", error);
      }
      commit("setIsFetching", false);
    },
    clearShops({ commit }) {
      commit("setShopList", null);
    },
  },
  getters: {
    getShopList(state) {
      return state.shopList;
    },
  },
};

export default shop;
